AOS.init();

(function () {
    document.addEventListener('DOMContentLoaded', () => {
        const htmlTag = document.documentElement;
        const highContrastBtn = document.querySelector('.high-contrast-btn');

        if (localStorage.getItem('highContrast') === 'true') {
            htmlTag.classList.add('high-contrast');
        }

        if (highContrastBtn) {
            highContrastBtn.addEventListener('click', (e) => {
                e.preventDefault();
                htmlTag.classList.toggle('high-contrast');
                const isHighContrast = htmlTag.classList.contains('high-contrast');
                localStorage.setItem('highContrast', isHighContrast);
            });
        }
    });
})();

function initSizePage() {
    let htmlTag = document.documentElement; ('html');
    let changePageSizeButton = document.querySelectorAll('a[data-size-switcher]');

    if (localStorage.getItem('dataPageSizeMultiProduct') !== null) {
        htmlTag.setAttribute('data-font-size', localStorage.getItem('dataPageSizeMultiProduct'));
        changePageSizeButton.forEach(btn => btn.classList.remove('active'));
        document.querySelector(`a[data-size-switcher="${localStorage.getItem('dataPageSizeMultiProduct')}"]`).classList.add('active');
    } else {
        localStorage.setItem('dataPageSizeMultiProduct', 'small');
    }

    changePageSizeButton.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            let size = btn.getAttribute('data-size-switcher');
            htmlTag.setAttribute('data-font-size', size);
            localStorage.setItem('dataPageSizeMultiProduct', size);
            changePageSizeButton.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
        });
    });
}
initSizePage();